module.exports = __webpack_public_path__ + "static/media/Skarner_0.48ef4fba.png";